import { render } from "./MixedChart.vue?vue&type=template&id=32367d54"
import script from "./MixedChart.vue?vue&type=script&lang=ts"
export * from "./MixedChart.vue?vue&type=script&lang=ts"
script.render = render

export default script